// NPM dependencies
// import $ from 'jquery';
// import 'foundation-sites';
import 'lazysizes';
import pictureFill from 'picturefill';
import objectFitImages from 'object-fit-images';
import Cookies from 'js-cookie';
import Headroom from "headroom.js";
// import 'slick-carousel';
// import 'lightgallery';
// import 'lg-thumbnail';

import InfiniteScroll from 'infinite-scroll';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesLoaded';

// var AOS = require('aos');

// var jQueryBridget = require('jquery-bridget');

// make Infinite Scroll a jQuery plugin
// jQueryBridget('infiniteScroll', InfiniteScroll, jQuery);
// Make masonry a jQuery plugin
// jQueryBridget('masonry', Masonry, jQuery);
// Make images loaded a jQuery plugin
// jQueryBridget( 'imagesLoaded', imagesLoaded, jQuery );

// Project Partials
import Map from '../../src/components/02-objects/map/map';
import GlobalNotice from '../../src/components/02-objects/global-notice/global-notice';
import Gallery from '../../src/components/03-ui/gallery/gallery';
import SiteHeader from '../../src/components/03-ui/site-header/site-header';
import Slider from '../../src/components/03-ui/slider/slider';

// Small JS Modules
import InfiniteMasonry from './modules/infinite-scroll-masonry';
import SmoothScroll from './modules/smooth-scroll';
import WooCommerce from './modules/woocommerce';

jQuery(document).ready(() => {
	// Init foundation on doc ready
	jQuery(document).foundation();

  // Object Fit Polyfill
  // https://github.com/bfred-it/object-fit-images
  objectFitImages();

	// Picture Polyfill
	// http://scottjehl.github.io/picturefill/
	pictureFill();

	// Initialise imported js (this would be js required for every page, globally, i.e. headers
	// Object.init();
  if ( typeof google === 'object' && typeof google.maps === 'object' ) {
    Map.init();
  }

  GlobalNotice.init(Cookies)
  Gallery.init();
	SiteHeader.init(Headroom);
  Slider.init();

	// Init small modules
  InfiniteMasonry.init(Masonry, imagesLoaded);
	SmoothScroll.init();
  WooCommerce.init();
});

// Foundation equalizer fix due to ionicons and other 3rd party libs
jQuery(window).on('load', function () {
	// Fix Equalizer woes
	jQuery(document).foundation();
	Foundation.reInit(jQuery('[data-equalizer]'));
});

// Init Animate on Scroll
// https://michalsnik.github.io/aos/
AOS.init({
	startEvent: 'load'
});

// Fix for AOS if required. When using some varied transitions along with equalizer,
// you may need to recalc height. To do so, just make sure the last element has data-aos-id="last-aos"
// document.addEventListener('aos:in', ({ detail }) => {
// 	// console.log('animated in', detail);
//
// 	if (detail.getAttribute('data-aos-id') === 'last-aos') {
// 		// console.log("Last element loaded");
// 		setTimeout(function () {
// 			// console.log("Equalizer should be fixed");
// 			Foundation.reInit(jQuery('[data-equalizer]'));
// 		}, 1000);
// 	}
// });
